import axios from 'axios';
import { serverUrl } from '../components/Helpers/Config';

const setupServices = () => {
    axios.interceptors.request.use(
        config => {
            config.headers['Content-Type'] = 'application/json';

            let token = localStorage.getItem('dp2_token_access')
            // config.headers.Authorization =  token ? `Bearer ${token}` : '';

            let userCode = ''
            if (config.url.startsWith(serverUrl.GuestShowcase)) {
                userCode = config.url.substring(serverUrl.GuestShowcase.length + 1)?.split('?')[0];
            }
            else if (config.url.startsWith(serverUrl.LoadGuestUser)) {
                userCode = config.url.substring(serverUrl.LoadGuestUser.length + 1);
            }
            else if (config.url.startsWith(serverUrl.GuestReflectionPost)) {
                userCode = config.url.substring(serverUrl.GuestReflectionPost.length + 1);
            }
            if (userCode.length > 0) {
                const indexSlash = userCode.indexOf("/");
                if (indexSlash > 0) userCode = userCode.substring(0, indexSlash);

                token = localStorage.getItem('dp2_token_access_' + userCode)
            }

            config.headers['x-auth-token'] = token ? token : '';

            return config
        },
        error => {
            return Promise.reject(error)
        }
    )

    axios.interceptors.response.use(
        response => {
            return response;
        },
        error => {
            if (error.response &&
                (error.response.status === 401 || error.response.data.message === '401 Unauthorized')
            ) {

            }
            return Promise.reject(error)
        }
    )
}

export default setupServices;